<template>
<div class="chapter">
<div class="inner_page">
<nav epub:type="toc" id="toc" role="doc-toc">
<h1 id="toc-title">Beautiful Star &amp; Other Stories</h1>
<ol class="toc">
<li>
<span href="#/text/cover" title="Link target outside of Sample">Cover</span>
</li>
<li id="title_page">
<a href="#/text/title_page">Title Page</a>
</li>
<li id="toc-li-1">
<a href="#/text/ch001#dedication">Dedication</a>
</li>
<li id="toc-li-2">
<a href="#/text/ch002#preface">Preface</a>
</li>
<li id="toc-li-3">
<a href="#/text/ch003#beautiful-star">Beautiful Star</a>
<ol class="toc">
<li id="toc-li-4">
<a href="#/text/ch003#section">1875</a>
</li>
</ol>
</li>
<li id="toc-li-5">
<span href="#/text/ch004#authors-note" title="Link target outside of Sample">Author’s Note</span>
<ol class="toc">
<li id="toc-li-6">
<span href="#/text/ch004#the-st-monans-families-were" title="Link target outside of Sample">The St Monans families were:</span>
</li>
<li id="toc-li-7">
<span href="#/text/ch004#the-lost-boats-and-their-crews-were" title="Link target outside of Sample">The lost boats and their crews were:</span>
</li>
</ol>
</li>
<li id="toc-li-8">
<span href="#/text/ch005#the-flying-monk" title="Link target outside of Sample">The Flying Monk</span>
<ol class="toc">
<li id="toc-li-9">
<span href="#/text/ch005#ad" title="Link target outside of Sample">1002 AD</span>
</li>
<li id="toc-li-10">
<span href="#/text/ch005#ad-1" title="Link target outside of Sample">1066 AD</span>
</li>
</ol>
</li>
<li id="toc-li-11">
<span href="#/text/ch006#hms-association" title="Link target outside of Sample">HMS <em>Association</em></span>
<ol class="toc">
<li id="toc-li-12">
<span href="#/text/ch006#section-1" title="Link target outside of Sample">1708</span>
<ol class="toc">
<li id="toc-li-13">
<span href="#/text/ch006#a-true-account-of-the-final-voyage-of-hms-association-by-daniel-jones-pressed-man." title="Link target outside of Sample">A true account of the final voyage of HMS <em>Association</em> by Daniel Jones, pressed man.</span>
</li>
</ol>
</li>
</ol>
</li>
<li id="toc-li-14">
<span href="#/text/ch007#the-tree" title="Link target outside of Sample">The Tree</span>
<ol class="toc">
<li id="toc-li-15">
<span href="#/text/ch007#section-2" title="Link target outside of Sample">1651</span>
</li>
</ol>
</li>
<li id="toc-li-16">
<span href="#/text/ch008#the-castle" title="Link target outside of Sample">The Castle</span>
<ol class="toc">
<li id="toc-li-17">
<span href="#/text/ch008#june-1645" title="Link target outside of Sample">June 1645</span>
</li>
</ol>
</li>
<li id="toc-li-18">
<span href="#/text/ch009#a-witch-and-a-bitch" title="Link target outside of Sample">A Witch and a Bitch</span>
<ol class="toc">
<li id="toc-li-19">
<span href="#/text/ch009#section-3" title="Link target outside of Sample">1730</span>
</li>
</ol>
</li>
<li id="toc-li-20">
<span href="#/text/ch010#the-button-seller-and-the-drummer-boy" title="Link target outside of Sample">The Button Seller and the Drummer Boy</span>
<ol class="toc">
<li id="toc-li-21">
<span href="#/text/ch010#section-4" title="Link target outside of Sample">1815</span>
<ol class="toc">
<li id="toc-li-22">
<span href="#/text/ch010#the-button-seller" title="Link target outside of Sample">The Button Seller</span>
</li>
<li id="toc-li-23">
<span href="#/text/ch010#the-drummer-boy" title="Link target outside of Sample">The Drummer Boy</span>
</li>
</ol>
</li>
<li id="toc-li-24">
<span href="#/text/ch010#section-5" title="Link target outside of Sample">1820</span>
</li>
</ol>
</li>
<li id="toc-li-25">
<span href="#/text/ch011#acknowledgements" title="Link target outside of Sample">Acknowledgements</span>
</li>
<li id="toc-li-26">
<span href="#/text/ch012#copyright" title="Link target outside of Sample">Copyright</span>
</li>
</ol>
</nav>
<nav epub:type="landmarks" hidden="hidden" id="landmarks">
<ol>
<li>
<span epub:type="cover" href="#/text/cover" title="Link target outside of Sample">Cover</span>
</li>
<li>
<a epub:type="toc" href="#/nav#toc">Table of Contents</a>
</li>
<li>
<a epub:type="bodymatter" href="#/text/title_page">Start of Content</a>
</li>
</ol>
</nav>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// nav.vue?5338eded